import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { PureComponent } from "react";

export default class Loading extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      modal: props.modal,
      status: false
    };
  }

  show(modal = false) {
    return new Promise(resolve => {
      this.setState({ status: true, modal }, resolve);
    });
  }

  hide() {
    this.setState({ status: false });
  }

  renderLoading() {
    return (
      <div className="loading">
        <FontAwesomeIcon icon={faSpinner} spin={true} size="2x" color="#fff" />
      </div>
    );
  }

  render() {
    if (!this.state.status) {
      return null;
    }
    return (
      <>
        {this.state.modal ? (
          <div className="loading-mask">{this.renderLoading()}</div>
        ) : this.renderLoading()}
      </>
    );
  }

}